import { ActivityIcon, RulesIcon, ClassIcon } from "@icons";
import { Command, CommandItem } from "@vendor/cmdk/cmdk";
import { FC, useCallback } from "react";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import { useCommands } from "./useCommands";

export const WorkspaceCommandsList: FC = () => {
    const { close: closeCommands } = useCommands();
    const navigate = useStateAwareNavigate();
    const { enabled: isGlFirst } = useIsGlFirst();

    const handleSelected = useCallback(
        (path: string) => {
            navigate(path);
            closeCommands();
        },
        [closeCommands, navigate],
    );

    return (
        <Command.Group heading="Workspace">
            {!isGlFirst && (
                <CommandItem
                    keywords={["custom"]}
                    onSelect={() => handleSelected("/categories")}
                >
                    <ActivityIcon /> Go to Categories
                </CommandItem>
            )}

            <CommandItem
                keywords={["categorization", "category"]}
                onSelect={() => handleSelected("/rules")}
            >
                <RulesIcon /> Go to Rules
            </CommandItem>

            <CommandItem onSelect={() => handleSelected("/classes")}>
                <ClassIcon /> Go to Classes
            </CommandItem>
        </Command.Group>
    );
};
